export default __webpack_public_path__ + "static/media/ninjatransfers-logo_white.32f4f17d.png";